import React from 'react';

interface LoadingOverlayProps {
    message?: string;
    subMessage?: string;
    isFullPage?: boolean;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
    message = "PROCESSING ASSETS...",
    subMessage = "COMMITTING DATA TO LOCAL PROJECT STORAGE",
    isFullPage = true
}) => {
    return (
        <div className={`${isFullPage ? 'fixed' : 'absolute'} inset-0 z-[1000] bg-slate-900/60 backdrop-blur-md flex flex-col items-center justify-center p-8 animate-fadeIn`}>
            <div className="relative group">
                {/* Outer rotating ring */}
                <div className="w-32 h-32 border-4 border-[#0000a9]/20 border-t-[#0000a9] rounded-full animate-spin"></div>

                {/* Inner reverse rotating ring */}
                <div className="absolute inset-4 border-4 border-slate-300/20 border-b-slate-300 rounded-full animate-spin [animation-duration:1.5s] [animation-direction:reverse]"></div>

                {/* Center icon */}
                <div className="absolute inset-0 flex items-center justify-center">
                    <svg className="w-8 h-8 text-white animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                    </svg>
                </div>
            </div>

            <div className="mt-12 text-center space-y-4">
                <h3 className="text-white font-black text-xl uppercase tracking-[0.4em] italic drop-shadow-lg">
                    {message}
                </h3>
                <div className="flex items-center justify-center gap-3">
                    <div className="h-[2px] w-8 bg-[#0000a9]"></div>
                    <p className="text-slate-200 text-[10px] font-black uppercase tracking-[0.3em]">
                        {subMessage}
                    </p>
                    <div className="h-[2px] w-8 bg-[#0000a9]"></div>
                </div>
            </div>

            {/* Progress detail */}
            <div className="absolute bottom-12 left-0 right-0 flex justify-center">
                <div className="px-6 py-2 bg-slate-800/50 border border-slate-700 backdrop-blur-sm">
                    <p className="text-[#0000a9] font-mono text-[9px] uppercase tracking-widest animate-pulse">
                        FILE_SYSTEM_ACCESS_API :: STREAMING_DATA_BLOB
                    </p>
                </div>
            </div>
        </div>
    );
};
